import { Card } from "@/frontend/components/common";
import { FaUsers, FaTrophy, FaFutbol } from "react-icons/fa";
import type { StageConfig } from "@/core/value-objects/StageConfig";
import { InfoCard } from "./InfoCard";

interface StageHeaderProps {
  stage: StageConfig;
}

export function StageHeader({ stage }: StageHeaderProps) {
  return (
    <Card className="shadow-sm" style={{ marginBottom: 24 }}>
      <div className="text-center py-8">
        <div
          className={`w-20 h-20 mx-auto rounded-full flex items-center justify-center mb-4 ${
            stage.type === "GROUPS"
              ? "bg-blue-100 text-blue-600"
              : stage.type === "KNOCKOUT"
                ? "bg-red-100 text-red-600"
                : "bg-green-100 text-green-600"
          }`}
        >
          {stage.type === "GROUPS" && <FaUsers size={32} />}
          {stage.type === "KNOCKOUT" && <FaTrophy size={32} />}
          {stage.type === "PLAYOFF" && <FaFutbol size={32} />}
        </div>
        <h3 className="text-xl font-bold text-gray-900">{stage.name}</h3>

        <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-2xl mx-auto">
          {stage.type === "GROUPS" && stage.structure.groupsCount && (
            <InfoCard
              label="Grupos"
              value={stage.structure.groupsCount.toString()}
            />
          )}
          {stage.type === "GROUPS" && stage.structure.teamsPerGroup && (
            <InfoCard
              label="Equipos por grupo"
              value={stage.structure.teamsPerGroup.toString()}
            />
          )}
          <InfoCard
            label="Ida y vuelta"
            value={stage.structure.isDoubleLeg ? "Sí" : "No"}
          />
          {stage.structure.hasExtraTime !== undefined && (
            <InfoCard
              label="Prórroga"
              value={stage.structure.hasExtraTime ? "Sí" : "No"}
            />
          )}
          {stage.structure.hasPenalties !== undefined && (
            <InfoCard
              label="Penaltis"
              value={stage.structure.hasPenalties ? "Sí" : "No"}
            />
          )}
          <InfoCard
            label="Clasificados"
            value={stage.progression.promotedCount.toString()}
          />
        </div>

        {stage.rules && stage.type !== "KNOCKOUT" && (
          <div className="mt-6 p-4 bg-gray-50 rounded-lg max-w-md mx-auto">
            <h4 className="font-medium text-gray-700 mb-2">Puntuación</h4>
            <div className="flex justify-center gap-6 text-sm">
              <span className="text-green-600 font-bold">
                Victoria: {stage.rules.pointsPerWin} pts
              </span>
              <span className="text-yellow-600 font-bold">
                Empate: {stage.rules.pointsPerDraw} pts
              </span>
              <span className="text-red-600 font-bold">
                Derrota: {stage.rules.pointsPerLoss} pts
              </span>
            </div>
          </div>
        )}
      </div>
    </Card>
  );
}
